<template>
  <div>
    <Popover
      popper-class="popover-cell"
      placement="bottom-end"
      v-model="visible"
      :visible-arrow="false"
      @show="showPopup"
      @after-enter="focusInput"
      @hide="saveInput">
      <div class="popover-content">
        <div class="list-popover">
          <label>{{ invoiceUnit }}</label>
          <span v-if="readonly" class="text-field">
            <span class="is-disabled ml-10">
              0
            </span>
            <span style="color: #A3A3A3">
              <strong>
                <Tooltip :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{  $t('NO_OF_MATERIALS_RETURNED') }}</div>
                  <span>
                    +
                  </span>
                </Tooltip>
                <Ellipsis
                  :text="`${returnedCount}`"
                  length="3"
                />
              </strong>
            </span>
          </span>
          <div v-else class="text-field">
            <input
              ref="inputRef"
              type="number"
              v-model="currentCount"
              min="0"
              onkeypress="return (event.charCode !=8 && event.charCode ==0 ||
                (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)"
            >
            <span class="ml-10" style="color: #A3A3A3">
              <Tooltip :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{  $t('NO_OF_MATERIALS_RETURNED') }}</div>
                <span>
                  +
                </span>
              </Tooltip>
              <Ellipsis
                :text="`${returnedCount}`"
                length="3"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="position-relative" slot="reference" @click="show">
        <div class="cell-value" :class="{'pl-35': isFirstColumn}">
          <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
            <div slot="content">{{ value }}&nbsp;{{ value ? invoiceUnit : '' }}</div>
            <div class="text-ellipsis pointer">{{ value }}&nbsp;{{ value ? invoiceUnit : '' }}</div>
          </Tooltip>
        </div>
      </div>
    </Popover>
  </div>
</template>

<script>
export default {
  name: 'ReturnMaterials',
  props: {
    material: {
      type: Object,
      required: true,
    },
    isFirstColumn: {
      type: Boolean,
      default: () => false,
    },
    unsavedReturnMaterialDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentCount: 0,
      visible: false,
    };
  },
  computed: {
    value() {
      return this.unsavedReturnMaterialDetails[this.material.id] || this.material.return_count || 0;
    },
    remainingMaterials() {
      return this.material.quantity.value - (this.material.epod.shortage_count || 0) - this.returnedCount;
    },
    invoiceUnit() {
      return this.material.quantity.unit.toLowerCase();
    },
    readonly() {
      return this.remainingMaterials <= 0;
    },
    returnedCount() {
      return this.material.return_count || 0;
    },
  },
  methods: {
    showPopup() {
      this.currentCount = this.unsavedReturnMaterialDetails[this.material.id] || 0;
    },
    show() {
      this.visible = true;
    },
    focusInput() {
      if (this.$refs.inputRef) {
        this.$refs.inputRef.focus();
      }
    },
    saveInput() {
      if (this.readonly) return;
      this.currentCount = this.currentCount || 0;
      const materialId = this.material.id;
      if (this.remainingMaterials < this.currentCount) {
        this.currentCount = 0;
        this.$errorMessage({
          message: this.$t('RETURN_COUNT_EXCEED_ERROR'),
        });
      } else {
        this.$emit('update-return-count', { materialId, returnCount: this.currentCount });
      }
    },
  },
};
</script>
